"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/material/styles");
var _ToggleButton = _interopRequireDefault(require("@mui/material/ToggleButton"));
var _ToggleButtonGroup = _interopRequireDefault(require("@mui/material/ToggleButtonGroup"));
var _styles2 = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _String = _interopRequireDefault(require("./String"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles2.makeStyles)(theme => {
  return {
    grid: {
      "--button-border-color": theme.palette.mode !== "dark" ? "#e0e0e0" : "#3a3a3a"
    },
    buttonDisabled: {
      cursor: "not-allowed",
      color: `${(0, _styles.alpha)(theme.palette.text.primary, 0.5)} !important`
    },
    buttonSelected: {
      backgroundColor: props => `${(0, _styles.alpha)(theme.palette[props.color].main, 0.1)} !important`,
      color: props => theme.palette[props.color].main
    }
  };
});
const ButtonGrid = props => {
  const classes = useStyles(props);
  const handleButtonMouseEnter = value => {
    props.onButtonMouseEnter?.(value);
  };
  const renderButtonGrid = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButtonGroup.default, {
      className: props.className,
      color: "primary",
      disabled: props.disabled,
      fullWidth: props.fullWidth,
      name: props.name,
      orientation: props.orientation,
      value: props.value,
      exclusive: true,
      onChange: (e, value) => props.onChange(value, props.name),
      size: props.size,
      children: props.items.map((item, key) => {
        const isSelected = item.id === props.value || item.value === props.value;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButton.default, {
          className: `${isSelected ? classes.buttonSelected : ""} ${item.disabled ? classes.buttonDisabled : ""} ${props.classNameButton || ""} ${item.className || ""}`.trim(),
          onMouseEnter: () => handleButtonMouseEnter(item.value),
          onMouseLeave: props.onButtonMouseLeave,
          selected: isSelected,
          value: item.value,
          children: item.label
        }, key);
      })
    });
  };
  const renderLabelled = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      gap: 0.5,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "textSecondary",
        str: props.label,
        variant: "overline"
      }), renderButtonGrid()]
    });
  };
  return props.label ? renderLabelled() : renderButtonGrid();
};
ButtonGrid.propTypes = {
  color: _propTypes.default.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]),
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  items: _propTypes.default.array,
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  onButtonMouseEnter: _propTypes.default.func,
  onButtonMouseLeave: _propTypes.default.func,
  orientation: _propTypes.default.oneOf(["horizontal", "vertical"]),
  size: _propTypes.default.oneOf(["small", "medium", "large"]),
  value: _propTypes.default.any
};
ButtonGrid.defaultProps = {
  color: "primary",
  fullWidth: false,
  orientation: "horizontal",
  size: "medium"
};
var _default = exports.default = ButtonGrid;